// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSaveRecommendationRequest,
  TSaveRecommendationModel,
  IMappers,
  TSaveRecommendationResponse_,
  TSaveRecommendationResponse,
  TSaveRecommendationResponse_1,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSaveRecommendationModel(parameters: TSaveRecommendationRequest): TSaveRecommendationModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'job-vacancies-backend',
    pathApi: '/v2/save-recommendation/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export const defaultConfig = createSaveRecommendationModel({} as unknown as TSaveRecommendationRequest);

export interface ISaveRecommendationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSaveRecommendationRequest;
}

export async function fetchSaveRecommendation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISaveRecommendationOptions<TResponse200, TResponse400>): Promise<
  TSaveRecommendationResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSaveRecommendationModel(parameters),
    config,
  )) as FetchResponse<TSaveRecommendationResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSaveRecommendationResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TSaveRecommendationResponse;
}
